import { Box, Button, Chip, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { ExamNoQuestion } from "models/managerTest";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import AccessTimeIcon from "@material-ui/icons/AccessTime";

export interface TimeoutProps {
  exam: ExamNoQuestion;
  isMobile: boolean;
}

export default function Timeout({ exam, isMobile }: TimeoutProps) {
  const navigate = useNavigate();
  const useStyles = makeStyles((theme: Theme) => ({
    btn_detail: {
      background: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
      borderRadius: 10,
      color: "#FFFFFF",
      padding: "6px 18px",
      fontWeight: 800,
      fontSize: "0.85rem",
      textTransform: "none",
      boxShadow: "0 4px 14px rgba(16, 185, 129, 0.35)",
      transition: "all 0.25s ease",
      "&:hover": {
        background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
        boxShadow: "0 6px 18px rgba(16, 185, 129, 0.5)",
        transform: "scale(1.03)",
      },
      [theme.breakpoints?.down("sm")]: {
        padding: "4px 10px",
        fontSize: "0.75rem",
        minWidth: 50,
      },
    },
    timeChip: {
      backgroundColor: "#EFF6FF",
      color: "#0284C7",
      fontWeight: 800,
      border: "1px solid #BAE6FD",
      fontSize: "0.825rem",
      padding: "4px 8px",
    },
  }));
  const classes = useStyles();

  const [now, setNow] = useState<number>(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleDateTime = () => {
    if (!exam || !exam.startDate) return null;

    const currentMs = now;
    const startMs = new Date(exam.startDate).getTime();
    // 15 minutes before start date
    const openMs = startMs - 15 * 60 * 1000;
    const examEndDate = (exam as any).endDate;
    const endMs = examEndDate
      ? new Date(examEndDate).getTime()
      : startMs + 30 * 24 * 60 * 60 * 1000;

    const handleNavigate = (e?: React.MouseEvent<any>) => {
      if (e) e.stopPropagation();
      navigate(`/exam/${exam?.id}`, {
        state: {
          id: exam?.id,
          startDate: exam?.startDate,
          examTitle: exam?.title,
          prize: exam?.prize,
        },
      });
    };

    // 1. Exam ended
    if (currentMs > endMs) {
      return (
        <Chip
          label="Đã kết thúc"
          size="small"
          style={{ backgroundColor: "#F1F5F9", color: "#94A3B8", fontWeight: 700 }}
        />
      );
    }

    // 2. Exam is OPEN now (either 15 mins before start OR currently running before endDate)
    if (currentMs >= openMs && currentMs <= endMs) {
      return (
        <Button
          size="small"
          className={classes.btn_detail}
          endIcon={<PlayArrowIcon />}
          onClick={handleNavigate}
        >
          Vào thi
        </Button>
      );
    }

    // 3. Exam is in the future (> 15 mins away) -> show countdown chip (clickable to enter waiting page)
    const diff = moment.duration(moment(startMs).diff(moment(currentMs)));
    const days = Math.floor(diff.asDays());
    const hours = diff.hours();
    const minutes = diff.minutes();

    let labelText = `Còn ${minutes} phút`;
    if (days > 0) {
      labelText = hours > 0 ? `Còn ${days} ngày ${hours} giờ` : `Còn ${days} ngày`;
    } else if (hours > 0) {
      labelText = minutes > 0 ? `Còn ${hours} giờ ${minutes} phút` : `Còn ${hours} giờ`;
    }

    return (
      <Chip
        icon={<AccessTimeIcon style={{ fontSize: 16, color: "#0284C7" }} />}
        label={labelText}
        size="small"
        className={classes.timeChip}
        onClick={handleNavigate}
        style={{ cursor: "pointer" }}
      />
    );
  };

  return <>{handleDateTime()}</>;
}
